// @ts-nocheck

import {useEffect, useState} from "react";

// @ts-ignore
import * as FireStoreParser from 'firestore-parser';
import max from "lodash/max";
import {addDays, addYears, isAfter, isBefore, parse} from "date-fns";
import {useGetPackagesByTripIdQuery} from "../slices/firestore-slice";
import {PackagesInterface, LiveabaordPackage} from "../types/package";

export default function useTripPackages(tripId: string) {

    const {data, error, isLoading, isFetching} = useGetPackagesByTripIdQuery(tripId)

    const [tripPackages, setTripPackages] = useState<PackagesInterface | null>(null);

    useEffect(() => {

        if (data) {

            const {liveaboard, resort, diveshop} = data

            if (!!liveaboard) {
                setTripPackages(liveaboard);
                return
            }
            if (!!resort) {
                setTripPackages(resort);
                return
            }
            if (!!diveshop) {
                setTripPackages(diveshop);
                return
            }
        }
    }, [data])


    const getAvailabilityForPeriod = (divePeriod: string) => {


        if (!tripPackages) return null
        //parse the period - "2020-dec"

        let inputPeriod = parse(divePeriod, "yyyy-MMM", new Date());
        inputPeriod = addDays(inputPeriod, 28)

        while (isBefore(inputPeriod, new Date())) {
            inputPeriod = addYears(inputPeriod, 1);
        }

        // -1: no avail, 0: don't know, 1: def avail

        const available = Object.keys(tripPackages.periods).reduce((result, key, idx, array) => {

            const [start, end] = key.split("_");

            const startParsed = parse(start, start.length === 7 ? "yyyy-MM" : "yyyy-MM-dd", new Date());

            let existsInPeriodKey = false;

            //check the start
            existsInPeriodKey = (startParsed.getFullYear() === inputPeriod.getFullYear()
                && startParsed.getMonth() === inputPeriod.getMonth());

            if (end) {
                //check the end
                const endParsed = parse(end, end.length === 7 ? "yyyy-MM" : "yyyy-MM-dd", new Date());
                existsInPeriodKey = existsInPeriodKey || (endParsed.getFullYear() === inputPeriod.getFullYear()
                    && endParsed.getMonth() === inputPeriod.getMonth());

                //check in between
                existsInPeriodKey = existsInPeriodKey || isAfter(inputPeriod, startParsed) && isBefore(inputPeriod, endParsed);

                //check if period is within the month

            }

            if (existsInPeriodKey) {
                const availArray = tripPackages.periods[key].map((p) => {

                    if (p.availability && p.availability === "FULL") {
                        return -1;
                    } else if (p.availability && (p.availability === "AVAILABLE" || p.availability === "SPECIAL_PRICE")) {
                        return 1;
                    } else {
                        return 0;
                    }

                });

                return max(availArray);
            }

            if (idx === array.length - 1 && result === null && !existsInPeriodKey) {
                return -1;
            }

            return result;

        }, null);
        /*
        resort:
        loop through periods, check if period key contains divePeriod, if so, loop though periods and
        look at .availability (may not exist(diveshop) or be null)
         */

        //console.log(inputPeriod.toDateString());

        return available;

    };

    return {tripPackages, getAvailabilityForPeriod, isFetchingPackages: isFetching};
}

